import { render, staticRenderFns } from "./technician-card.vue?vue&type=template&id=2ee8efff&scoped=true&"
import script from "./technician-card.vue?vue&type=script&lang=js&"
export * from "./technician-card.vue?vue&type=script&lang=js&"
import style0 from "./technician-card.vue?vue&type=style&index=0&id=2ee8efff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8efff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
